import { alchemy, chain } from "@/config";
import { JsonRpcProvider, AlchemyProvider, Provider, BrowserProvider } from "ethers";

export const roProvider: Provider =
  alchemy.network && alchemy.apiKey
    ? new AlchemyProvider(alchemy.network, alchemy.apiKey)
    : new JsonRpcProvider(chain.rpc);

export const providers: Record<number, BrowserProvider | Provider> = {};

export function registerProvider(provider: BrowserProvider | Provider): number {
  providers[1] = provider;
  return 1;
}

export function getProvider(providerId: number): BrowserProvider | Provider | undefined {
  return providers[providerId];
}
